import React from 'react';

export default function LanguageSwitcher({ language, onChange }) {
  return (
    <div className="language-switcher-inner">
      <button aria-label="Polish" onClick={() => onChange('pl')} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}>
        <img src={process.env.PUBLIC_URL + '/img/flags/pl.png'} alt="Polski" style={{ width: 28, height: 20, borderRadius: 2, border: language === 'pl' ? '2px solid #2980b9' : '1px solid #ccc' }} />
        <span className={language === 'pl' ? 'nav-link active' : 'nav-link'} style={{ fontSize: '1rem', marginLeft: 4, fontWeight: language === 'pl' ? 700 : 400 }}>PL</span>
      </button>
      <button aria-label="English" onClick={() => onChange('en')} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}>
        <img src={process.env.PUBLIC_URL + '/img/flags/gb.png'} alt="English" style={{ width: 28, height: 20, borderRadius: 2, border: language === 'en' ? '2px solid #2980b9' : '1px solid #ccc' }} />
        <span className={language === 'en' ? 'nav-link active' : 'nav-link'} style={{ fontSize: '1rem', marginLeft: 4, fontWeight: language === 'en' ? 700 : 400 }}>EN</span>
      </button>
    </div>
  );
}
